// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3Rb0q","title":"ClientCherryInfo_title__UyFmg","itemText":"ClientCherryInfo_itemText__2LaI2"};